import type { SignInWalkerResponse } from "wagAPI";
import type { SignInWalkerParsedResponse } from "webApp";
export const signInWalkerResponseParser = (response: SignInWalkerResponse): SignInWalkerParsedResponse => ({
  token: response.token,
  id: String(response.id),
  isPasswordCompliant: response.is_password_compliant,
  passwordResetJWT: response.password_reset_jwt
});
export default signInWalkerResponseParser;